<template>
    <div>
        <div class="content-caption bg-white dashed">
            <div class="fl">
                <span>工程师信息</span>
            </div>
        </div>
        <div class="form-single">
            <div class="title">工程师名称</div>
            <div class="content">
                <span>{{ engineer.name }}</span>
            </div>
        </div>
        <div class="form-single" v-if="engineer.serveNo != null">
            <div class="title">服务工号</div>
            <div class="content">
                <span>{{ engineer.serveNo }}</span>
            </div>
        </div>
        <div class="form-single" v-if="engineer.contactTel != null">
            <div class="title">联系电话</div>
            <div class="content">
                <span>{{ engineer.contactTel }}</span>
            </div>
        </div>
        <div class="form-single">
            <div class="title">负责数量</div>
            <div class="content">
                <span>{{ engineerShopList == null ? 0 : engineerShopList.length }}</span>
            </div>
        </div>
        <div class="content-caption bg-white dashed">
            <div class="fl">
                <span>负责网点信息</span>
            </div>
            <div class="swb-btn swb-btn-mini fr" @click="setEngineerShop">新增</div>
        </div>
        <div class="form-single">
            <div class="table-layout">
                <el-table :data="engineerShopList" ref="ssuList" border style="width: 100%">
                    <el-table-column prop="comName" label="网点名称" align="left"></el-table-column>
                    <el-table-column label="操作" align="left" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <a class="swb-btn-link" @click="deleteItem(rows.row.id)">移除</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
import { Utils } from '../../app.base'
import { Vue, MsgBox } from '../../app.vues'
import { openServicerComForSelectDlg } from './selectDlg'

import servicerApi from '../../api/servicer'

export default {
    name: 'swb-servicer-xngineer-shop-list',
    desc: '商户工程师-负责门店',
    props: ['xngineerId'],
    data: function () {
        return {
            engineer: {},
            engineerShopList: []
        }
    },
    created: function () {
        this.getServicerEngineer();
    },
    methods: {
        //初始化
        getServicerEngineer: function () {
            let self = this;
            let postData = {};
            postData.id = self.xngineerId;
            servicerApi.getServicerXngineer(postData, function (result) {
                if(result.type === "info") {
                    self.engineer = result.data;
                    self.getServicerXngineerShopList();
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getServicerXngineerShopList: function () {
            let self = this;
            let postData = {};
            postData.xngineerId = self.xngineerId;
            let loading = MsgBox.loading();
            servicerApi.getServicerEngineersForShop(postData, function (result) {
                loading.close();
                if(result.type === "info") {
                    self.engineerShopList = result.data || [];
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 分配网点
        setEngineerShop() {
            let self = this;
            let filter = {
                servicerComIds: self.engineerShopList.pluck("comId")
            }
            openServicerComForSelectDlg("网点选择", filter, true, function (selectComList) {
                let comIds = selectComList.pluck("id");
                let loading = MsgBox.loading();
                let postData = {
                    xngineerId: self.xngineerId,
                    comIds: comIds
                }
                servicerApi.saveServicerEngineerForXngineer(postData, function (result) {
                    loading.close();
                    if(result.type === "info") {
                        self.getServicerXngineerShopList();
                        //
                        MsgBox.success("操作成功");
                    } else {
                        MsgBox.warning(result.message);
                    }
                });

            });
        },
        deleteItem(id) {
            let self = this;
            this.$confirm('确定要移除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function (value) {
                if(value) {
                    let postData = {};
                    postData.id = id;
                    let theLoad = MsgBox.loading();
                    servicerApi.deleteServicerEngineer(postData, function (result) {
                        theLoad.hide();
                        if(result.type == "info") {
                            self.getServicerXngineerShopList();
                            MsgBox.success("操作成功");
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
            }).catch(function () {
            });
        }
    }
}
</script>

<style>
.form-single .content .enum-item:nth-child(2n) {
    margin-left: 2%;
}
</style>



// WEBPACK FOOTER //
// src/compo/orgStruct/ServicerXngineerShopList.vue